import React, { createContext, useState } from 'react';

const PromotionModalContext = createContext();
export default PromotionModalContext;

const { Provider } = PromotionModalContext;

// 모달 아이템
export const PromotionItem = '20240415_miraeasset';
export const PromotionStartDate = '2024-04-15T00:00:00+09:00';
export const PromotionEndDate = '2024-07-01T00:00:00+09:00';

const PromotionModalProvider = (props) => {
  const [showModal, setShowModal] = useState(false);

  const doShowModal = () => {
    const modalStatus = JSON.parse(localStorage.getItem(PromotionItem));
    const today = new Date().getTime();
    const startDate = new Date(PromotionStartDate).getTime();
    const endDate = new Date(PromotionEndDate).getTime();
    const isModalOn = today >= startDate && today < endDate

    !modalStatus && isModalOn
      ? setShowModal(true)
      : modalStatus && modalStatus.timestamp < today && isModalOn
      ? setShowModal(true)
      : setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const dayCloseModal = () => {
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    const time = JSON.stringify({
      timestamp: nextDay.getTime(),
    });
    localStorage.setItem(PromotionItem, time);
    setShowModal(false);
  };

  const context = {
    state: {
      showModal,
    },
    actions: {
      setShowModal,
      closeModal,
      dayCloseModal,
      doShowModal,
    },
  };

  return <Provider value={context}>{props.children}</Provider>;
};

export { PromotionModalProvider };
